import {isJsonString} from "@js/globalFunctions/isJsonString";

export function updateViableDatePickerDays()
{
	if(dataholder.miniferiePeriods === false)
		parseMiniferiePeriods();
	
	const selected = $('.datepicker__month-day--first-day-selected.datepicker__month-day--visibleMonth ,.datepicker__month-day--last-day-selected.datepicker__month-day--visibleMonth ');
	let selectedTs = false;
	let selectedWeekday = false;
	if(selected.length === 1)
	{
		selectedTs = Number($(selected).attr('time'));
		const selectedDate = new Date();
		selectedDate.setTime(selectedTs)
		selectedWeekday = selectedDate.getDay();
	}
	
	const now = new Date();
	const nowTs = now.getTime();
	const nowDate = now.getFullYear()+'-'+now.getMonth()+'-'+now.getDate();
	const nowHour = now.getHours();
	
	$('.datepicker__month-day.datepicker__month-day--visibleMonth').each((i,el) => {
		const viable = isElViable(el,nowTs,nowDate,nowHour,selectedTs,selectedWeekday);
		if(viable)
		{
			$(el).addClass('datepicker__month-day--valid').removeClass('datepicker__month-day--invalid')
		}
		else
		{
			$(el).removeClass('datepicker__month-day--valid').addClass('datepicker__month-day--invalid')
		}
	});
}

function isElViable(el,nowTs,nowDate,nowHour,selectedTs,selectedWeekday)
{
	//If its already one of the endpoints, allow
	if($(el).hasClass('datepicker__month-day--last-day-selected') || $(el).hasClass('datepicker__month-day--first-day-selected')) return true;
	
	const elTs = Number($(el).attr('time'));
	const elDate = new Date();
	elDate.setTime(elTs);
	elDate.setHours(12,0,0);
	
	const elDateString = elDate.getFullYear()+'-'+elDate.getMonth()+'-'+elDate.getDate();

	//If it's before now, or is today but after 12, decline
	if(elDateString === nowDate && nowHour < 12){}
	else if(elTs < nowTs) return false;
	
	let allowedWeekdays = []; // @todo change to [0,6,5,4] to reenable regular searches
	const isMiniferie = isInMiniferiePeriod(elDate.getTime());
	if(isMiniferie)
		allowedWeekdays = [0,1,2,3,4,5,6];
	else
		return false; // @todo Remove to reenable regular searches
	//If there is a selected date (only 1, ie. they are choosing their second date)
	if(selectedTs !== false)
	{
		const diff = Math.abs(elTs-selectedTs);
		const daysDiff = Math.floor(diff/1000/3600/24);
		
		//If it's within 3 days or above 28 days, there is no scenario where it's allowed - decline
		if(daysDiff < 3 || daysDiff > 5) return false; // @todo change upper limit to 28 to reenable regular searches
		
		//Only allow the second date to be of the selected weekday
		allowedWeekdays = (isMiniferie && (daysDiff === 3 || daysDiff === 4 || daysDiff === 5)) ? [0,1,2,3,4,5,6] : []; // @todo change last to [selectedWeekday] to reenable regular searches
	}
	
	//If it's not an allowed weekday, decline.
	if(allowedWeekdays.indexOf(elDate.getDay()) === -1)
		return false;
	
	return true;
}

function isInMiniferiePeriod(ts)
{
	let result = false;
	for(let i = 0; i < dataholder.miniferiePeriods.length; i++)
	{
		if(dataholder.miniferiePeriods[i].startTs <= ts && dataholder.miniferiePeriods[i].endTs >= ts)
		{
			result = true;
			break;
		}
	}
	return result;
}

function parseMiniferiePeriods()
{
	let periods = [];
	if(typeof miniFeriePerioder !== 'undefined' && isJsonString(miniFeriePerioder) )
	{
		const periodsRaw = JSON.parse(miniFeriePerioder);
		periodsRaw.forEach((el) => {
			const start = new Date(el.start+"T00:00:00Z"); //For at hjælpe safari med at forstå datoer.
			const slut = new Date(el.slut+"T12:00:00Z"); //---
			let period = {
				start: el.start,
				startTs: start.getTime(),
				end: el.slut,
				endTs: slut.getTime(),
			};
			periods.push(period);
		})
	}
	dataholder.miniferiePeriods = periods;
}
